import { TextField } from "@mui/material";
import React, { ReactNode } from "react";
import { AppButton } from "ui/Scripts/source/components/framework/Button/AppButton";

interface SearchFieldProps {
    value?: string;
    name?: string;
    disabled?: boolean;
    buttonVisible?: boolean;
    buttonTitle?: string;
    buttonIcon?: ReactNode;
    buttonDisabled?: boolean;
    buttonVariant?: "text" | "outlined" | "contained";
    helperText?: string;
    maxLength?: number;
    onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    onSubmit?: React.MouseEventHandler<HTMLButtonElement>;
}

export const SearchField = ({ value, name, disabled, buttonTitle, buttonIcon, buttonDisabled, buttonVariant = "outlined", buttonVisible = true, helperText, maxLength, onChange, onSubmit }: SearchFieldProps) => {
    return (
        <TextField
            type="text"
            name={name}
            onChange={onChange}
            disabled={disabled}
            value={value}
            size="small"
            fullWidth
            helperText={helperText}
            sx={{
                "& .MuiFormHelperText-root": {
                    marginLeft: 0,
                },
            }}
            inputProps={{ maxLength }}
            InputProps={{
                endAdornment: buttonVisible && (
                    <AppButton
                        variant={buttonVariant}
                        disabled={buttonDisabled}
                        onClick={onSubmit}
                        sx={{ marginRight: "-14px", borderRadius: "0 .25rem .25rem 0" }}
                    >{buttonTitle || buttonIcon}</AppButton>
                )
            }} />
    );
};
